import React from 'react';

import styles from './Table.css';

const TablePreRender = (props) => {
    const { height } = props;
    return (
        <div style={{ height }} className="table-pre-content">
            <style jsx>{styles}</style>
        </div>
    );
};

export default TablePreRender;
